<template>
    <tr class="amenity">
        <td class="align-middle">
            <fa-icon :icon="['fal', amenity.icon]" transform="grow-6" class="mr-2 amenity-icon text-primary" /> {{ amenity.title }}
        </td>
        <td v-show="false" class="align-middle">
            <custom-select name="price" v-model="amenity.price" :options="[{ 'label': 'Included', 'value': 0}, { 'label': 'Additional Charge', 'value': 1}]"></custom-select>
        </td>
        <td v-show="false" class="align-middle">
            <textarea name="description" class="form-control" v-model="amenity.description"></textarea>
        </td>
        <td class="align-middle text-right">
            <a href="#" @click.prevent="remove">
                <fa-layers class="mt-2">
                    <fa-icon :icon="['fas', 'circle']" class="text-light" transform="grow-8" />
                    <fa-icon :icon="['fas', 'times-circle']" transform="grow-5" />
                </fa-layers>
            </a>
        </td>
    </tr>
</template>

<script>
import CustomSelect from '@/components/form-controls/CustomSelect'

export default {
    components: {
        CustomSelect,
    },
    props: {
        amenity: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
        };
    },
    computed: {
    },
    watch: {
    },
    methods: {
        remove() {
            this.$emit('remove', this.amenity)
        },
    },
    mounted: function() {
    },
    updated: function() {
    }
}
</script>

<style scoped>
.form-group {
    margin-bottom: 0;
}
.amenity-icon {
    vertical-align: middle;
}
</style>
